/* Heavily inspired from material-ui ClickAwayListener.js */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import EventListener from 'react-event-listener';
import { omit } from '@design-systems/utils';

const { element, func } = PropTypes;

/** Runs a function when the dom is clicked outside of the ClickAwayListener */
export default class ClickAwayListener extends React.Component {
  static propTypes = {
    /**
     * The  wrapped element
     */
    children: element.isRequired,
    /**
     * Callback on click away.
     */
    onClickAway: func
  };

  static defaultProps = {
    onClickAway: () => {}
  };

  constructor(props) {
    super(props);
    this.mounted = null;
  }

  componentDidMount() {
    this.mounted = true;

    // eslint-disable-next-line react/no-find-dom-node
    this.node = ReactDOM.findDOMNode(this);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleClickAway = event => {
    // Ignore events that have been `event.preventDefault()` marked.
    if (event.defaultPrevented) {
      return;
    }

    // IE11 support, which trigger the handleClickAway even after the unbind
    if (!this.mounted) {
      return;
    }

    // The child might render null.
    if (!this.node) {
      return;
    }

    const doc = this.node.ownerDocument;

    if (
      doc.documentElement &&
      doc.documentElement.contains(event.target) &&
      !this.node.contains(event.target)
    ) {
      this.props.onClickAway(event);
    }
  };

  render() {
    const { children, ...restProps } = omit(this.props, ['onClickAway']);

    return (
      <>
        {children}
        <EventListener
          target="document"
          onMouseUp={this.handleClickAway}
          {...restProps}
        />
      </>
    );
  }
}
